import React, { useRef, useState, useEffect } from 'react';
import { Slider, Fade } from '@mui/material';
import styles from './headcountSlider.module.scss';
import { HtmlTooltip } from 'constants/tooltip';
import { addThousandSeparator } from 'utils/numbers';
import { getFormatSeparatorsOptions } from 'config/marketConfig';

import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const CustomSlider = withStyles({
  root: {
    color: '#3A3E43',
    height: 60,
    padding: '0',
  },
  track: {
    height: 60,
    borderRadius: 2,
  },
  thumb: {
    height: 32,
    width: 17,
    backgroundColor: 'none',
    border: 'none',
    borderRadius: 24,
    color: '#fff',
    pointerEvents: 'all',
  },
  rail: {
    backgroundColor: '#eeeff0',
    opacity: 1,
  },
})(Slider);

export default function HeadcountSlider(props) {
  const { t } = useTranslation();
  const {
    onChange,
    value,
    headcount,
    inOffice,
    fullyRemote,
    hybrid,
    max,
    fullyInOfficeTooltip,
    fullyRemoteTooltip,
    hybridTooltip,
    disabled,
  } = props;
  const slider = useRef();

  const [midSectionWidth, setMidSectionWidth] = useState(0);
  const [firstSectionWidth, setFirstSectionWidth] = useState(0);

  useEffect(() => {
    setMidSectionWidth(slider.current.children[1].clientWidth);
    setFirstSectionWidth(slider.current.children[1].offsetLeft);
  }, []);

  const handleChange = (event, newValue, activeThumb) => {
    onChange(event, newValue, activeThumb);
    setMidSectionWidth(slider.current.children[1].clientWidth);
    setFirstSectionWidth(slider.current.children[1].offsetLeft);
    if (event.type === 'mousedown') {
      setTimeout(() => {
        setMidSectionWidth(slider.current.children[1].clientWidth);
        setFirstSectionWidth(slider.current.children[1].offsetLeft);
      }, 90);
    }
  };

  const definePeopleCount = (people) => {
    return addThousandSeparator(
      Math.round((people * headcount) / 100),
      getFormatSeparatorsOptions(),
    );
  };

  return (
    <div className={styles.slider_wrapper}>
      <div className={`${styles.slider_container} ${disabled && styles.slider_container_disabled}`}>
        <CustomSlider
          disabled={disabled}
          data-testid="HeadcountSlider"
          ref={slider}
          value={value}
          onChange={handleChange}
          max={max}
        />
        <div className={styles.slider_mask}>
          <HtmlTooltip
            data-testid={'fullyInOfficeTooltip'}
            title={fullyInOfficeTooltip}
            TransitionComponent={Fade}
            placement="bottom">
            <div
              className={styles.slider_mask__section}
              style={{ width: `${firstSectionWidth}px` }}>
              <span>{t('step2.inOffice')}</span>
              <div data-testid="InOfficeValue">
                {definePeopleCount(inOffice)} ({inOffice}%)
              </div>
            </div>
          </HtmlTooltip>
          <HtmlTooltip
            data-testid={'fullyRemoteTooltip'}
            title={fullyRemoteTooltip}
            TransitionComponent={Fade}
            placement="bottom">
            <div className={styles.slider_mask__section} style={{ width: `${midSectionWidth}px` }}>
              <span>{t('step2.remote')}</span>
              <div data-testid="FullyRemoteValue">
                {definePeopleCount(fullyRemote)} ({fullyRemote}%)
              </div>
            </div>
          </HtmlTooltip>
          <HtmlTooltip
            data-testid={'hybridTooltip'}
            title={hybridTooltip}
            TransitionComponent={Fade}
            placement="bottom">
            <div className={styles.slider_mask__section}>
              <span>{t('step2.hybrid')}</span>
              <div data-testid="HybridValue">
                {definePeopleCount(hybrid)} ({hybrid}%)
              </div>
            </div>
          </HtmlTooltip>
        </div>
      </div>
    </div>
  );
}
